import { Component } from '@angular/core';

@Component({
    selector: 'app-Video',
    template: `<router-outlet></router-outlet>`
})
export class VideoComponent {

}
